<template>
  <div :class="['testimonial-svg', { 'fonts-loaded': fontLoaded }]" v-html="svg" />
</template>
<script>
import SvgTestimonial from '../lib/SvgTestimonial'
import { injectFontFamily } from '@lib/injectFont'

export default {
  name: 'TestimonialSvg',
  props: {
    renderableTestimonial: { type: Object, required: true },
    theme: { type: Object, required: true },
  },
  data() {
    return {
      fontLoaded: false,
      fontError: null,
    }
  },
  computed: {
    svgTemplate() {
      return this.theme.svg_template
    },
    svg() {
      const svgTestimonial = new SvgTestimonial(this.svgTemplate, this.renderableTestimonial)
      return svgTestimonial.markup()
    },
    themeHasCustomFonts() {
      return this.theme.font_families?.length > 0
    },
  },
  watch: {
    theme: {
      handler() {
        this.loadFonts()
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    loadFonts() {
      this.fontLoaded = false

      if (!this.themeHasCustomFonts) {
        this.fontLoaded = true
        return Promise.resolve()
      }

      this.theme.font_families.forEach((fontFamily) => {
        injectFontFamily(fontFamily, fontFamily.name)
      })

      // Use document.fonts.ready to detect when fonts are loaded
      return document.fonts.ready
        .then(() => {
          this.fontLoaded = true
        })
        .catch((error) => {
          this.fontError = `Error loading fonts: ${error.message}`
          // eslint-disable-next-line no-console
          console.error(this.fontError)
        })
    },
  },
}
</script>

<style lang="sass" scoped>
.testimonial-svg
  svg
    text, tspan
      white-space: wrap
      font-family: initial
</style>
